import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';
import { EmblaDots } from '@/components/Carousel/styled';

export const sectionHeading = css`
  font-size: 2.8rem;
  font-weight: 300;
  line-height: 36px;
  letter-spacing: -0.02em;
  strong {
    font-weight: 700;
  }
`;
export const ReviewContainerRow = styled(Row)`
  text-align: center;
  padding-top: ${({ theme }) => theme.x6spacePx}px;
  padding-bottom: ${({ theme }) => theme.x4spacePx}px;
`;

export const StyledReactMarkdown = styled('div')`
  h2 {
    ${sectionHeading}
    color: ${({ theme }) => theme.color.spaceGray};
    margin: ${({ theme }) => theme.x4spacePx}px
      ${({ theme }) => theme.x2spacePx}px;
    ${media.lgUp`
      ${({ theme }) => theme.typography.mass}
      max-width: 700px;
      font-weight: 300;
      margin: ${({ theme }) => theme.x5spacePx}px auto;
    `}
  }

  p {
    color: ${({ theme }) => theme.color.spaceGray};
  }
`;

export const ReviewCarouselRow = styled(Row)`
  position: relative;
  min-width: 320px;
  padding-bottom: ${({ theme }) => theme.x4spacePx}px;
  ${EmblaDots} {
    bottom: -20px;
  }
  ${media.mdUp`
    width: 100%;
    ${EmblaDots} {
      bottom: -10px;
    }
  `}
`;

export const StyledReviewReactMarkdown = styled('div')`
  width: 300px;
  ${media.lgUp`
    width: 240px;
    padding: 0 ${({ theme }) => theme.x2spacePx}px;
  `}
  text-align: left;
  > p:first-child {
    padding-left: ${({ theme }) => theme.x8spacePx}px;
    position: relative;
    color: ${({ theme }) => theme.color.spaceGrayRGBA(0.5)};
    ${({ theme }) => theme.typography.tiny}
    strong {
      color: ${({ theme }) => theme.color.spaceGray};
      ${({ theme }) => theme.typography.xSmallStrong}
    }
    img {
      position: absolute;
      left: 0;
    }
  }
  p:nth-child(2) {
    height: ${({ theme }) => theme.x4spacePx}px;
  }
`;
